import { heroStats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -right-24 top-1/2 hidden h-[420px] w-[420px] -translate-y-1/2 rounded-full bg-accent-100/60 blur-3xl lg:block" />
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:py-24">
        <div className="animate-fade-up w-full">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-fire-line text-sm text-primary-500" />
            </span>
            <span className="text-xs font-medium text-primary-700">
              热度榜每 10 分钟滚动更新
            </span>
          </div>

          <h1 className="font-heading text-[34px] font-bold leading-[1.15] tracking-tight text-foreground-950 md:text-[46px] lg:text-[52px]">
            31黑料网
            <span className="mt-2 block text-primary-600">黑料热度排行专题站</span>
          </h1>

          <p className="mt-6 max-w-xl text-[15px] leading-[1.9] text-foreground-700">
            这里把每天散落在各处的热议话题，整理成可追溯的
            <strong className="font-semibold text-foreground-900">31黑料网黑料排行</strong>
            ，从
            <strong className="font-semibold text-foreground-900">31黑料网热门黑料</strong>
            到专题合集式的
            <strong className="font-semibold text-foreground-900">31黑料网黑料榜单</strong>
            ，一条条排好、归档、标注来源时间，方便你顺着时间线把一件事看完整。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#ranking"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-bar-chart-2-line text-base" />
              </span>
              查看今日热度榜
            </a>
            <a
              href="#collections"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-stack-line text-base" />
              </span>
              浏览专题合集
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-1 gap-4 border-t border-background-300/70 pt-6 sm:grid-cols-3 sm:gap-6">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs font-medium tracking-wide text-foreground-500">
                  {stat.label}
                </dt>
                <dd className="mt-1.5 font-heading text-2xl font-bold text-foreground-950">
                  {stat.value}
                </dd>
                <dd className="mt-1 text-[11px] text-secondary-600">{stat.note}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-fade-up delay-2 relative w-full">
          <div className="relative h-[380px] w-full overflow-hidden rounded-lg md:h-[480px] lg:h-[560px]">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20cover%20artwork%20of%20an%20abstract%20human%20silhouette%20behind%20frosted%20glass%20under%20crimson%20and%20gold%20stage%20spotlights%2C%20dramatic%20shadows%2C%20floating%20dust%20particles%2C%20deep%20warm%20dark%20background%2C%20high%20contrast%20cinematic%20mood%2C%20no%20text%20no%20face&width=900&height=1100&seq=hero-main&orientation=portrait"
              alt="31黑料网热度榜封面插画"
              title="31黑料网黑料排行封面"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
          </div>

          <div className="absolute -bottom-5 left-4 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 shadow-none md:left-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100">
              <i className="ri-fire-fill text-xl text-accent-600" />
            </span>
            <div>
              <p className="text-[11px] font-medium text-foreground-500">当前最火黑料热度</p>
              <p className="font-heading text-xl font-bold text-foreground-950">286.4万</p>
            </div>
          </div>

          <div className="absolute right-4 top-4 flex items-center gap-2 rounded-full bg-background-50/95 px-3 py-1.5 md:right-6">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-history-line text-sm text-primary-500" />
            </span>
            <span className="text-xs font-medium text-foreground-800">实时更新中</span>
          </div>
        </div>
      </div>
    </section>
  );
}